import { MessageTypesUI } from '@/enums/viewEnums.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { helpers } from '@/helpers.ts';
import { Toast } from '@/components/Toast/Toast.tsx';

export const handleDialogRequestDeclined = (ctxData: WebSocketMessage) => {
  if (ctxData.dialog_request_declined_event?.contact.hid) {
    helpers.toast({
      id: MessageTypesUI.TYPE_GIFT_REJECT,
      content: (
        <Toast
          type={MessageTypesUI.TYPE_GIFT_REJECT}
          contact={ctxData.dialog_request_declined_event?.contact}
        />
      )
    });
  }
};
